"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _classnames = _interopRequireDefault(require("classnames"));

var _constants = require("composer-lib/lib/constants");

var _KeyCommandAccessible = _interopRequireDefault(require("composer-lib/components/composer/KeyCommandAccessible"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _createReactClass = _interopRequireDefault(require("create-react-class"));

var _react = _interopRequireDefault(require("react"));

var _reactAddonsPureRenderMixin = _interopRequireDefault(require("react-addons-pure-render-mixin"));

// Wrap your editors in this component so that the CSS for the editors container is handled automatically
// If you want to further nest your editors in other elements, you need to use `KeyCommandAccessible` to do so
// in levels deeper than EditorsGroup to ensure that the editor nodes get the key command props correctly.
var _default = (0, _createReactClass.default)({
  displayName: "EditorsGroup",
  mixins: [_reactAddonsPureRenderMixin.default],
  propTypes: {
    addKeyCommandListener: _propTypes.default.func,
    children: _propTypes.default.node.isRequired,
    className: _propTypes.default.string,
    handleKeyCommand: _propTypes.default.func,
    removeKeyCommandListener: _propTypes.default.func
  },
  preventEditorBlur: function preventEditorBlur(e) {
    var targetClassName = e.target.className;

    if (_constants.NO_BLUR_TARGETS.includes(targetClassName)) {
      e.preventDefault();
    }
  },
  render: function render() {
    var _this$props = this.props,
        addKeyCommandListener = _this$props.addKeyCommandListener,
        children = _this$props.children,
        className = _this$props.className,
        handleKeyCommand = _this$props.handleKeyCommand,
        removeKeyCommandListener = _this$props.removeKeyCommandListener;
    var keyCommandProps = {
      addKeyCommandListener: addKeyCommandListener,
      handleKeyCommand: handleKeyCommand,
      removeKeyCommandListener: removeKeyCommandListener
    };
    var classes = (0, _classnames.default)(_constants.EDITORS_CONTAINER_CLASSNAME, (0, _defineProperty2.default)({}, className, !!className));
    return _react.default.createElement(_KeyCommandAccessible.default, Object.assign({
      className: classes,
      onMouseDown: this.preventEditorBlur
    }, keyCommandProps), _react.default.createElement(_KeyCommandAccessible.default, Object.assign({
      className: _constants.EDITORS_GROUP_CLASSNAME
    }, keyCommandProps), children));
  }
});

exports.default = _default;
module.exports = exports.default;